module.exports = __webpack_public_path__ + "static/media/defaultUser.4b1bb228.png";